"use strict";

exports.__esModule = true;
exports.createAuctionStorages = exports.createAuctionManagerStorages = void 0;
var _storage = require("../utils/storage");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createAuctionStorages = api => {
  return {
    collateralAuctions: id => _storage.Storage.create({
      api: api,
      path: 'query.auctionManager.collateralAuctions',
      params: [id]
    }),
    auction: id => _storage.Storage.create({
      api: api,
      path: 'query.auction.auctions',
      params: [id]
    })
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
exports.createAuctionStorages = createAuctionStorages;
const createAuctionManagerStorages = api => {
  return {
    auctions: () => _storage.Storage.create({
      api: api,
      path: 'query.auctionManager.collateralAuctions.keys',
      params: [],
      events: [{
        method: 'NewCollateralAuction',
        section: 'auctionManager'
      }]
    })
  };
};
exports.createAuctionManagerStorages = createAuctionManagerStorages;